import styled from '@emotion/styled'
import {ReactNode} from 'react'

type SocialLinkProps = {
  href: string
  icon: ReactNode
}

const HoveringLink = styled.a`
  color: #A4A7AE;

  &:hover {
    color: #344054;
  }
`

export const SocialLink = ({href, icon}: SocialLinkProps) => (
  <HoveringLink href={href}>{icon}</HoveringLink>
)
